import 'react-native-url-polyfill/auto';
import { createClient } from '@supabase/supabase-js';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { supabaseErrorHandler } from './supabaseErrorHandler';

const supabaseUrl = process.env.EXPO_PUBLIC_SUPABASE_URL || '';
const supabaseAnonKey = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY || '';

/**
 * CRITICAL: Install error interceptor BEFORE creating Supabase client
 * This ensures Supabase uses our wrapped fetch instead of the original
 */
supabaseErrorHandler.installInterceptor();

/**
 * Create Supabase client AFTER interceptor is installed
 * This way the client will use our error-handling fetch wrapper
 */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: AsyncStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

/**
 * Note: Must call supabaseErrorHandler.initialize() from App.tsx
 * after DialogProvider is mounted to enable dialog functionality
 */
